import { useQuery } from "@tanstack/react-query";
import { CalendarX } from "lucide-react";
import { fetchGames } from "@/lib/api";
import GameCard from "@/components/GameCard";
import SectionHeader from "@/components/SectionHeader";
import { TimezoneBar } from "@/components/TimezoneBar";
import { Skeleton } from "@/components/ui/skeleton";

const SKELETONS = ["a", "b", "c", "d", "e", "f"];

export function Board() {
  const { data, isLoading } = useQuery({ queryKey: ["games"], queryFn: fetchGames, staleTime: 5 * 60_000 });
  const games = data?.games || [];

  return (
    <section className="mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-24 lg:px-8" data-testid="tonights-board-section">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <SectionHeader
          eyebrow="Upcoming Board"
          title="Upcoming NBA Fixtures"
          sub="Real, verified NBA fixtures from the official schedule feed — shown in your local time. Picks are only ever added after personal research."
          testid="board-header"
        />
        {data?.source === "balldontlie" && <span className="tag mb-10 border border-[#00E676]/40 bg-[#00E676]/10 text-[#00E676] sm:mb-14" data-testid="board-live-badge">Live schedule · BALLDONTLIE</span>}
      </div>
      <div className="mb-8"><TimezoneBar compact /></div>

      {isLoading ? (
        <div className="grid gap-4 sm:gap-6 sm:grid-cols-2 lg:grid-cols-3">{SKELETONS.map((k) => <Skeleton key={k} className="h-56 rounded-xl bg-[#141A26]" />)}</div>
      ) : games.length === 0 ? (
        <div className="panel flex flex-col items-center px-6 py-16 text-center" data-testid="board-empty-state">
          <CalendarX size={32} className="text-slate-600" />
          <h3 className="mt-4 font-display text-lg font-bold uppercase tracking-wide text-white">No NBA games in the next 7 days</h3>
          <p className="mt-2 max-w-sm text-sm text-slate-400">{data?.source === "unavailable" ? "The fixture feed is not connected yet." : "The schedule is clear right now — fixtures appear here automatically when the league publishes them."}</p>
        </div>
      ) : (
        <div className="grid gap-4 sm:gap-6 sm:grid-cols-2 lg:grid-cols-3">{games.map((g, i) => <GameCard key={g.id} game={g} index={i} />)}</div>
      )}
    </section>
  );
}

export default Board;
